import { DEFAULT_LIST_PARAMS_FOR_SESSION_PAGE } from "@/constants/api"
import { getTrackListLoader } from "@/features/session"
import { getSessionListLoader } from "@/features/session/api/getSessionList"
import { getEventDayUpComingLoader } from "@/features/Shared/apis/getEventDateUpcoming"
import { isInApp } from "@/utils/in-app-checker"
import { signinInSign } from "@/utils/signin-insign"
import { defer } from "react-router-dom"

export type TAppSessionLoader = {
  sessionList: Awaited<ReturnType<typeof getSessionListLoader>>
  trackList: Awaited<ReturnType<typeof getTrackListLoader>>
  eventDate: Awaited<ReturnType<typeof getEventDayUpComingLoader>>
}

const fakeTrackParams = {
  pageLimit: 100,
  pageNumber: 1
}

export const sessionLoader = async () => {
  // if (isInApp()) {
  //   await signinInSign()
  // }
  // edward123

  const trackList = await getTrackListLoader(fakeTrackParams)
  const eventDate = await getEventDayUpComingLoader()
  const sessionList = await getSessionListLoader({
    trackIds: [],
    eventDate: eventDate.startDate,
    pageLimit: DEFAULT_LIST_PARAMS_FOR_SESSION_PAGE.LIMIT,
    pageNumber: DEFAULT_LIST_PARAMS_FOR_SESSION_PAGE.PAGE
  })
  return defer({
    sessionList,
    trackList,
    eventDate
  })
}

export const appSessionLoader = async () => {
  if (isInApp()) {
    await signinInSign()

    return sessionLoader()
  }

  throw new Response("Not Found", { status: 404 })
}
